import i18next from 'i18next'
import responseFields from '../../constants/responseFields'
import {
    baseCheckboxInput,
    baseDateInput,
    baseMultiSelectInput,
    baseNumberInput,
    basePriceInput,
    baseSelectInput,
    baseTextAreaInput,
    baseTextInput,
} from '../fieldTypes'
import { companyGeneralFields, companyOtherInfoFields } from './fields'

export const companyGeneralFieldTypes = () => {
    const { t } = i18next

    return {
        [companyGeneralFields.ID]: {
            ...baseTextInput,
            name: companyGeneralFields.ID,
            label: t('form.company.general.id'),
            disabled: true,
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.NAME]: {
            ...baseTextInput,
            name: companyGeneralFields.NAME,
            label: t('app.common.name'),
            required: true,
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.FULL_NAME]: {
            ...baseTextInput,
            name: companyGeneralFields.FULL_NAME,
            label: t('app.common.company.fullName'),
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.CONTACT_LEGAL_FORM_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.CONTACT_LEGAL_FORM_ID,
            label: t('app.common.company.legalForm'),
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.TAX_NUMBER]: {
            ...baseTextInput,
            name: companyGeneralFields.TAX_NUMBER,
            label: t('app.common.pin'),
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.INITIAL_CONTACT_DATE]: {
            ...baseDateInput,
            name: companyGeneralFields.INITIAL_CONTACT_DATE,
            label: t('app.common.contact.establishmentDate'),
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.CONTACT_PRIORITY_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.CONTACT_PRIORITY_ID,
            label: t('form.contact.general.priority'),
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.DATA_SOURCE_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.DATA_SOURCE_ID,
            label: t('app.common.contact.dataSource'),
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.PHONE_NUMBER]: {
            ...baseTextInput,
            name: companyGeneralFields.PHONE_NUMBER,
            label: t('app.common.phoneNumber'),
        },
        [companyGeneralFields.CONTACT_PHONE_TYPE_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.CONTACT_PHONE_TYPE_ID,
            label: t('form.contact.general.phoneType'),
        },
        [companyGeneralFields.EMAIL]: {
            ...baseTextInput,
            name: companyGeneralFields.EMAIL,
            label: t('app.common.email.label'),
        },
        [companyGeneralFields.CONTACT_EMAIL_TYPE_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.CONTACT_EMAIL_TYPE_ID,
            label: t('form.contact.general.emailType'),
        },
        [companyGeneralFields.NEWSLETTER_APPROVAL]: {
            ...baseCheckboxInput,
            name: companyGeneralFields.NEWSLETTER_APPROVAL,
            label: t('form.contact.general.newsletter.label'),
            tooltip: t('form.contact.general.newsletter.tooltip'),
        },
        [companyGeneralFields.WEBSITE]: {
            ...baseTextInput,
            name: companyGeneralFields.WEBSITE,
            label: t('app.common.web'),
        },
        [companyGeneralFields.STREET]: {
            ...baseTextInput,
            name: companyGeneralFields.STREET,
            label: t('app.common.street'),
        },
        [companyGeneralFields.STREET_NUMBER]: {
            ...baseTextInput,
            name: companyGeneralFields.STREET_NUMBER,
            label: t('app.common.streetNumber'),
        },
        [companyGeneralFields.ZIP_CODE]: {
            ...baseTextInput,
            name: companyGeneralFields.ZIP_CODE,
            label: t('form.contact.general.zipCode'),
        },
        [companyGeneralFields.CITY]: {
            ...baseTextInput,
            name: companyGeneralFields.CITY,
            label: t('app.common.cityMunicipality'),
        },
        [companyGeneralFields.CONTACT_COUNTRY_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.CONTACT_COUNTRY_ID,
            label: t('app.common.country'),
        },
        [companyGeneralFields.CONTACT_QUERY_CATEGORY_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.CONTACT_QUERY_CATEGORY_ID,
            label: t('app.common.contact.queryCategory'),
        },
        [companyGeneralFields.CONTACT_ID]: {
            ...baseTextInput,
            name: companyGeneralFields.CONTACT_ID,
            label: t('form.company.general.contactPerson'),
        },
        [companyGeneralFields.CONTACT_STATUS_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.CONTACT_STATUS_ID,
            label: t('app.common.status'),
            required: true,
            colProps: {
                sm: 12,
            },
        },
        [companyGeneralFields.AGENT_ID]: {
            ...baseSelectInput,
            name: companyGeneralFields.AGENT_ID,
            label: t('app.common.agent'),
            required: true,
        },
    }
}

export const companyOtherInfoFieldTypes = () => {
    const { t } = i18next

    return {
        [companyOtherInfoFields.CONTACT_DESCRIPTION_ID]: {
            ...baseSelectInput,
            name: companyOtherInfoFields.CONTACT_DESCRIPTION_ID,
            label: t('form.company.other.description'),
            colProps: {
                sm: 12,
            },
        },
        [companyOtherInfoFields.CONTACT_CORE_BUSINESS_ID]: {
            ...baseSelectInput,
            name: companyOtherInfoFields.CONTACT_CORE_BUSINESS_ID,
            label: t('app.common.company.coreBusiness'),
        },
        [companyOtherInfoFields.CONTACT_COMPANY_SIZE_ID]: {
            ...baseSelectInput,
            name: companyOtherInfoFields.CONTACT_COMPANY_SIZE_ID,
            label: t('app.common.company.size'),
        },
        [companyOtherInfoFields.EMPLOYEES_NO]: {
            ...baseNumberInput,
            name: companyOtherInfoFields.EMPLOYEES_NO,
            label: t('app.common.company.employeesNumber'),
        },
        [companyOtherInfoFields.BANK_ACCOUNT_NO]: {
            ...baseTextInput,
            name: companyOtherInfoFields.BANK_ACCOUNT_NO,
            label: t('app.common.company.bankAccount'),
        },
        [companyOtherInfoFields.REGISTRY_COURT]: {
            ...baseTextInput,
            name: companyOtherInfoFields.REGISTRY_COURT,
            label: t('app.common.company.registryCourt'),
        },
        [companyOtherInfoFields.SHARE_CAPITAL]: {
            ...basePriceInput,
            name: companyOtherInfoFields.SHARE_CAPITAL,
            label: t('app.common.company.shareCapital'),
        },
        [companyOtherInfoFields.INITIAL_CALL_INFO]: {
            ...baseTextAreaInput,
            name: companyOtherInfoFields.INITIAL_CALL_INFO,
            label: t('form.contact.other.initialCallInfo'),
            colProps: {
                sm: 12,
            },
            inputProps: {
                style: { resize: 'none', height: '170px' },
            },
        },
        [companyOtherInfoFields.NOTES]: {
            ...baseTextAreaInput,
            name: companyOtherInfoFields.NOTES,
            label: t('app.common.remark'),
            colProps: {
                sm: 12,
            },
            inputProps: {
                style: { resize: 'none', height: '170px' },
            },
        },
    }
}

export const companyDetailSearchFieldTypes = () => {
    const { t } = i18next

    return {
        [responseFields.NAME]: {
            ...baseTextInput,
            name: responseFields.NAME,
            label: t('app.common.company.name'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CONTACT_PHONE]: {
            ...baseTextInput,
            name: responseFields.CONTACT_PHONE,
            label: t('app.common.phoneNumber'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CONTACT_EMAIL]: {
            ...baseTextInput,
            name: responseFields.CONTACT_EMAIL,
            label: t('app.common.email.label'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.AGENT]: {
            ...baseSelectInput,
            name: responseFields.AGENT,
            label: t('app.common.agent'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.INITIAL_CONTACT_DATE_FROM]: {
            ...baseDateInput,
            name: responseFields.INITIAL_CONTACT_DATE_FROM,
            placeholder: t('app.common.from'),
            colProps: {
                sm: 6,
                className: 'pe-0',
            },
        },
        [responseFields.INITIAL_CONTACT_DATE_TO]: {
            ...baseDateInput,
            name: responseFields.INITIAL_CONTACT_DATE_TO,
            placeholder: t('app.common.to'),
            colProps: {
                sm: 6,
            },
        },
        [responseFields.LAST_ACTIVITY_DATE_FROM]: {
            ...baseDateInput,
            name: responseFields.LAST_ACTIVITY_DATE_FROM,
            placeholder: t('app.common.from'),
            colProps: {
                sm: 6,
                className: 'pe-0',
            },
        },
        [responseFields.LAST_ACTIVITY_DATE_TO]: {
            ...baseDateInput,
            name: responseFields.LAST_ACTIVITY_DATE_TO,
            placeholder: t('app.common.to'),
            colProps: {
                sm: 6,
            },
        },
        [responseFields.CONTACT_COUNTRY]: {
            ...baseSelectInput,
            name: responseFields.CONTACT_COUNTRY,
            label: t('app.common.country'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CITY]: {
            ...baseTextInput,
            name: responseFields.CITY,
            label: t('app.common.cityMunicipality'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CONTACT_STATUS]: {
            ...baseMultiSelectInput,
            name: responseFields.CONTACT_STATUS,
            label: t('app.common.status'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CONTACT_PROFILE_SERVICE]: {
            ...baseSelectInput,
            name: responseFields.CONTACT_PROFILE_SERVICE,
            label: t('form.company.companyDetailSearch.profileType'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CONTACT_PROFILE_STATUS]: {
            ...baseSelectInput,
            name: responseFields.CONTACT_PROFILE_STATUS,
            label: t('app.common.contact.profileStatus'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CONTACT_QUERY_CATEGORY]: {
            ...baseSelectInput,
            name: responseFields.CONTACT_QUERY_CATEGORY,
            label: t('app.common.contact.queryCategory'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.CONTACT_PRIORITY]: {
            ...baseSelectInput,
            name: responseFields.CONTACT_PRIORITY,
            label: t('app.common.contact.priority'),
            colProps: {
                sm: 12,
            },
        },
        [responseFields.DATA_SOURCE]: {
            ...baseSelectInput,
            name: responseFields.DATA_SOURCE,
            label: t('app.common.contact.dataSource'),
            colProps: {
                sm: 12,
            },
        },
    }
}
